import {RemotePatchFinishRequestPreview} from 'data/usecases/private/refund/request-preview';
import {PatchFinishRequestPreview} from 'domain/usecases/private/refund/request-preview';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makePatchFinishRequestPreview = (protocol: string): PatchFinishRequestPreview =>
	new RemotePatchFinishRequestPreview(
		makeBFFApiUrl(`${RefundFlowEndPoints.requestPreview}/${protocol}`),
		makeAuthorizeHttpClientDecorator(),
	);
